(function (define) {
    define([], function () {
        function getFlowCacheBuster() {
            try {
                const configElement = document.getElementById("app-config");
                if (!configElement) {
                    throw new Error("App configuration not found. Make sure the app-config script tag exists.");
                }

                const cachedConfig = JSON.parse(configElement.textContent || "{}");
                return cachedConfig.version || "";
            } catch (error) {
                console.warn("Failed to parse app configuration JSON", error);
                return "";
            }
        }

        const flowCacheBuster = getFlowCacheBuster();

        window.cacheBusters = { "framework/": flowCacheBuster };

        function cacheBuster(id, url) {
            if (url.indexOf("virtual/") === 0) {
                return url;
            }

            const matchingKeys = Object.keys(window.cacheBusters)
                .filter(function (key) {
                    return id.indexOf(key) === 0;
                })
                .sort(function (key1, key2) {
                    return key2.length - key1.length; // Opposite of usual, we want the longest first
                });

            let selectedCacheBuster = undefined;

            if (matchingKeys.length > 0) {
                selectedCacheBuster = window.cacheBusters[matchingKeys[0]];
            }

            if (!selectedCacheBuster) {
                selectedCacheBuster = flowCacheBuster; // Default to Flow cache buster
            }

            const args = "bust=" + selectedCacheBuster;
            const busterQuery = (url.indexOf("?") === -1 ? "?" : "&") + args;

            return busterQuery;
        }

        return {
            baseUrl: "dist/Scripts",
            urlArgs: cacheBuster,
            waitSeconds: 60,
            paths: {
                signalrHubs: "/WE.Notifications.Web/signalr/hubs?",
                views: "../../Views"
            },
            shim: {
                signalr: {
                    deps: ["jquery"]
                },
                signalrHubs: {
                    deps: ["jquery", "signalr"]
                }
            },
            map: {
                "*": {
                    "ko": "knockout",

                    "ko.mapping": "knockout-mapping",
                    "knockout.mapping": "knockout-mapping",
                    "koMapping": "knockout-mapping",

                    "ko.validation": "knockout.validation",
                    "knockout-validation": "knockout.validation",

                    "ko.plus": "3pp/ko.plus",
                    "fancytree": "jquery.fancytree",

                    "jqueryui": "jquery-ui",

                    "jquery-ui/ui/widgets/accordion": "jquery-ui",
                    "jquery-ui/ui/widgets/autocomplete": "jquery-ui",
                    "jquery-ui/ui/widgets/datepicker": "jquery-ui",
                    "jquery-ui/ui/widgets/droppable": "jquery-ui",
                    "jquery-ui/ui/widgets/menu": "jquery-ui",
                    "jquery-ui/ui/widgets/sortable": "jquery-ui",
                    "jquery-ui/ui/widgets/tabs": "jquery-ui",

                    "moment-with-locales": "moment",

                    "@lifecare-welfare/legacy-flow": "index",
                    "legacy-flow": "index",

                    "jqueryform": "jquery-form",
                    "pivot": "plotly-bundle",
                    "plotly_renderers": "plotly-bundle",
                    "c3-bundle": "plotly-bundle",
                    "jqueryGrid": "free-jqgrid",

                    "flow/bindings/editorBinding": "tinymce-enterprise",
                    "tinymce": "tinymce-enterprise",
                    "@lifecare-welfare/tinymce-enterprise": "tinymce-enterprise",
                    "jquerycontextmenu": "ui-contextmenu"
                }
            }
        };
    });
})(
    typeof define === "function" && define.amd
        ? define
        : function (_deps, factory) {
              window["require"] = factory();
          }
);

window.define('flow/require.config', [], function() { return __webpack_module__.exports; });